export default __webpack_public_path__ + "static/media/cross_red_icon.387b6c66.svg";